import React from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '~/components/TableCell';

import { AmountField, H2, H3, TextField } from '~/components';
import { Section } from '~/layout';
import collectProperties from '~/utils/collectProperties';
import { makeLabel } from './ContextTab';
import useStyles from './useStyles';
import { HeadTransaction } from '~/types/HeadTransaction';
import { CardTransaction } from '~/types/TransactionsHistory';

import CreditCardIcon from '@material-ui/icons/CreditCard';
import PosIcon from '@material-ui/icons/PhoneAndroid';
import OperationSubtypeField from '../list/OperationSubtypeField';

const CardTransactionSection = (props: {
  cardTransaction: CardTransaction;
  trx: HeadTransaction;
}) => {
  const { cardTransaction, trx } = props;

  const classes = useStyles();

  const translate = useTranslate();
  const t = (key: string) => translate(makeLabel(`cardTransaction.${key}`));

  const cardProperties = collectProperties(cardTransaction?.card || {});

  const cardAcceptorProperties = collectProperties(cardTransaction?.cardAcceptor || {});

  return (
    <>
      <header className={classes.header}>
        <H2 topSpacing={0} bottomSpacing={0}>
          {t('_')}
        </H2>
      </header>
      <Section className={`${classes.bottomSpacing}`}>
        <Grid container spacing={2} className={`${classes.bottomSpacing}`}>
          <Grid item xs={4}>
            <OperationSubtypeField
              keyPrefix='operationSubtype'
              operationSubtype={trx.operationSubtype}
              serviceId={trx?.details?.service?.id}
              label={t('operationSubtype')}
            />
          </Grid>
          {typeof cardTransaction.advice !== 'undefined' && (
            <Grid item xs={4}>
              <TextField label={t('advice')}>
                {cardTransaction.advice ? t('yes') : t('no')}
              </TextField>
            </Grid>
          )}
          {typeof cardTransaction.originalAmount !== 'undefined' && (
            <Grid item xs={4}>
              <AmountField amount={cardTransaction.originalAmount} label={t('originalAmount')} />
            </Grid>
          )}
        </Grid>
      </Section>
      {cardProperties.length > 0 && (
        <Section className={`${classes.bottomSpacing}`}>
          <H3 icon={<CreditCardIcon />} noPaddingLeft bottomSpacing={2}>
            {t('card')}
          </H3>
          <Grid container item xs={12}>
            <Table className={cx(classes.table, { [classes.autoWidth]: true })}>
              <TableHead>
                <TableRow>
                  <TableCell>{t('parameter')}</TableCell>
                  <TableCell>{t('data')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cardProperties.map((item) => (
                  <TableRow>
                    <TableCell title={item.key}>{`card.${item.key}`}</TableCell>
                    <TableCell>{item.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Section>
      )}
      {cardAcceptorProperties.length > 0 && (
        <Section className={`${classes.bottomSpacing}`}>
          <H3 icon={<PosIcon />} noPaddingLeft bottomSpacing={2}>
            {t('cardAcceptor')}
          </H3>
          <Grid container item xs={12}>
            <Table className={cx(classes.table, { [classes.autoWidth]: true })}>
              <TableHead>
                <TableRow>
                  <TableCell>{t('parameter')}</TableCell>
                  <TableCell>{t('data')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cardAcceptorProperties.map((item) => (
                  <TableRow>
                    <TableCell title={item.key}>{`cardAcceptor.${item.key}`}</TableCell>
                    <TableCell>{item.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Section>
      )}
    </>
  );
};

export default CardTransactionSection;
